<template>
  <v-layout row wrap>
    <div class="d-flex text-xs-center">
      <v-menu>
        <template #activator="{ on }">
          <v-btn
            outline
            small
            color="primary"
            :disabled="!selected.length"
            v-on="on"
          >
            {{ $t('fields.global.state') }}
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="item in statusItems"
            :key="item.title"
            @click="item.onClick"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu>
        <template #activator="{ on }">
          <v-btn
            outline
            small
            color="primary"
            :disabled="!selected.length"
            v-on="on"
          >
            {{ $t('fields.matches.publicSale') }}
          </v-btn>
        </template>
        <v-list>
          <v-list-tile
            v-for="item in publicSaleItems"
            :key="item.title"
            @click="item.onClick"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <ButtonConfirm
        color="primary"
        outline
        :text="$t('fields.matches.marked')"
        :disabled="!selected.length"
        @submit="bulkAction('update', { reviewed: true })"
      />
      <ButtonConfirm
        color="error"
        outline
        :text="$t('action.buttons.resetMatch')"
        :text-info="$t('titles.matches.resetMatchInfo')"
        :disabled="!selected.length"
        @submit="bulkAction('reset')"
      />
      <ButtonConfirm
        color="error"
        outline
        :text="$t('action.buttons.delete')"
        :text-info="$t('titles.matches.resetMatchInfo')"
        :disabled="!selected.length"
        @submit="bulkAction('delete')"
      />
    </div>
  </v-layout>
</template>

<script>
import vuetifyToast from 'vuetify-toast'
import EventBus from '@/EventBus'
import ButtonConfirm from '@/components/widgets/button/ButtonConfirm.vue'
import { apiAxios } from '@/helpers'
export default {
  name: 'ControlPanelBulkActions',
  components: {
    ButtonConfirm,
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      statusItems: [
        {
          title: 'Activo',
          onClick: () => this.bulkAction('update', { active: true }),
        },
        {
          title: 'Inactivo',
          onClick: () => this.bulkAction('update', { active: false }),
        },
      ],
      publicSaleItems: [
        {
          title: 'Activo',
          onClick: () => this.bulkAction('update', { publicSale: true }),
        },
        {
          title: 'Inactivo',
          onClick: () => this.bulkAction('update', { publicSale: false }),
        },
      ],
    }
  },
  methods: {
    async bulkAction(action, data) {
      let payload = {
        action,
        data,
        objectIds: this.selected.map((item) => item.id),
      }
      await apiAxios.post('matches/bulk-action', payload)

      vuetifyToast.show({
        text: this.$t('titles.global.action.success'),
        color: 'success',
        timeout: 2000,
        icon: 'check',
      })
      EventBus.$emit('fetch-control-panel')
      this.$emit('update:selected', [])
    },
  },
}
</script>
